module.exports = __webpack_public_path__ + "img/antes_despues_177.3dbc5090.png";